import React from 'react';

const Row = ({ params, row }) => {
    let td = getValues(params, row);

    return (
        <tr>{td}</tr>
    );
};

function getValues(params, row) {
    return params.map((param, index) => {
        let value = row[index];

        return(<td key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderCtrHourly/components/Table/components/Row/index.js